import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const baseSelectMenuClasses = generateUtilityClasses(
  'AFBaseSelectMenu',
  [
    'container',
    'searchContainer',
    'menu',
    'menuList',
    'noOptionsMessage',
    'loadingMessage'
  ]
);
